import { render } from "./Kiosks.vue?vue&type=template&id=d806a474"
import script from "./Kiosks.vue?vue&type=script&lang=js"
export * from "./Kiosks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__